'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import type { SystemStyleObject } from '@repo/pandacss/types';
import { useId } from 'react';
import { Tooltip } from '../Tooltip';
import type { AdvertiserDisclosurePosition } from './utils';
export const LABEL = 'Advertiser disclosure';
export function AdvertiserDisclosure(t0) {
  const $ = _c(23);
  const {
    containerStyles,
    position: t1,
    shouldCloseOnWidthResizing: t2,
    triggerStyles
  } = t0;
  const position = t1 === undefined ? "bottom-right" : t1;
  const shouldCloseOnWidthResizing = t2 === undefined ? false : t2;
  const headingId = useId();
  let t3;
  if ($[0] !== containerStyles) {
    t3 = containerStyles ? css(containerStyles) : undefined;
    $[0] = containerStyles;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = css({
      width: "[576px]",
      maxWidth: "[576px]",
      color: "neutral.darkest",
      rounded: "none",
      boxShadow: "[0 4px 8px 0 rgb(100 102 106/15%),0 8px 16px 0 rgb(100 102 106/33%)]",
      p: "[1rem 1rem 0.5rem 1rem]"
    });
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== triggerStyles) {
    t5 = css({
      fontSize: "[13px]",
      fontFamily: "[Gotham, sans-serif]",
      color: "lime.tintLP2",
      cursor: "pointer",
      fontWeight: "medium",
      _hover: {
        textDecoration: "underline"
      },
      ...triggerStyles
    });
    $[3] = triggerStyles;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <span className={t5}>{LABEL}</span>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = css({
      textStyle: "headline",
      color: "greens.main",
      mt: "2",
      mb: "0"
    });
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== headingId) {
    t8 = <h2 id={headingId} className={t7}>You're our first priority.</h2>;
    $[8] = headingId;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className={css({
      textStyle: "headline",
      color: "greens.main",
      mt: "2",
      mb: "3"
    })}>Every time.</p>;
    t10 = <p className={css({
      textStyle: "body.responsive",
      mb: "3"
    })}>We believe everyone should be able to make financial decisions with confidence. While we don't cover every company or financial product on the market, we work hard to share a wide range of offers and objective editorial perspectives.</p>;
    t11 = <p className={css({
      textStyle: "body.responsive",
      mb: "3"
    })}>So how do we make money? Our partners compensate us for advertisements that appear on our site or when you click to or take an action on their website. This compensation helps us provide tools and services - like free credit score access and monitoring. With the exception of mortgage, home equity and other home-lending products or services, partner compensation is one of several factors that may affect which products we highlight and where they appear on our site. Other factors include your credit profile, product availability and proprietary website methodologies.</p>;
    t12 = css({
      textStyle: "body.responsive",
      mb: "3"
    });
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t9;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t9 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <strong>do not influence our editors' opinions or ratings</strong>;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <p className={t12}>However, these factors{" "}{t13}, which are based on independent research and analysis. Our partners cannot pay us to guarantee favorable reviews.{" "}<a href="/p/our-partners" className={css({
        color: "blues.main",
        _hover: {
          textDecoration: "underline"
        }
      })}>Here is a list of our partners</a>.</p>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== headingId || $[17] !== position || $[18] !== shouldCloseOnWidthResizing || $[19] !== t3 || $[20] !== t6 || $[21] !== t8) {
    t15 = <Tooltip position={position} ariaLabel={LABEL} ariaLabelledBy={headingId} shouldCloseOnWidthResizing={shouldCloseOnWidthResizing} containerClassName={t3} contentClassName={t4} trigger={t6}>{t8}{t9}{t10}{t11}{t14}</Tooltip>;
    $[16] = headingId;
    $[17] = position;
    $[18] = shouldCloseOnWidthResizing;
    $[19] = t3;
    $[20] = t6;
    $[21] = t8;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
}